export function shouldUseUpgradeIconForAiEntry({ isBasic, canUpgradeToUseGenerativeAi }) {
    return !isBasic && canUpgradeToUseGenerativeAi;
}
